import { Link } from "react-router-dom";
import { CreditCard, ExternalLink, Loader2, Plus } from "lucide-react";

const plural = (count, singular, pluralLabel) => `${count} ${count > 1 ? pluralLabel : singular}`;

const SubscriptionCard = ({ user, totalCredits, onCustomerPortal, portalLoading, copy }) => {
  const freeCredits = Number(user?.free_credits || 0);
  const collectiveCredits = Number(user?.analysis_credits?.collective || 0);
  const individualCredits = Number(user?.analysis_credits?.individual || 0);
  const subscriptionCredits = Number(user?.subscription_credits || 0);
  const details = [
    subscriptionCredits > 0 ? `${subscriptionCredits} ${copy.subscription}` : null,
    freeCredits > 0 ? plural(freeCredits, copy.freeSingular, copy.freePlural) : null,
    collectiveCredits > 0 ? plural(collectiveCredits, copy.collectiveSingular, copy.collectivePlural) : null,
    individualCredits > 0 ? plural(individualCredits, copy.individualSingular, copy.individualPlural) : null,
  ].filter(Boolean).join(", ");

  return (
    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
      <p className="text-sm uppercase tracking-wide text-zinc-500 mb-2">{copy.title}</p>
      <div className="text-5xl font-black text-[#CCFF00] mb-2">{totalCredits}</div>
      <p className="text-gray-400 mb-6">{totalCredits > 0 ? `${copy.detailsPrefix} ${details}` : copy.noCredit}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {totalCredits > 0 ? (
          <Link to="/order" className="bg-[#CCFF00] hover:bg-[#AACC00] text-black font-semibold px-4 py-3 transition-colors flex items-center justify-center gap-2">
            <Plus className="w-4 h-4" />{copy.createOrder}
          </Link>
        ) : (
          <Link to="/pricing" className="bg-[#CCFF00] hover:bg-[#AACC00] text-black font-semibold px-4 py-3 transition-colors flex items-center justify-center gap-2">
            <CreditCard className="w-4 h-4" />{copy.buyCredit}
          </Link>
        )}
        <button onClick={onCustomerPortal} disabled={portalLoading} className="border border-white/20 hover:bg-white/10 text-white font-semibold px-4 py-3 transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
          {portalLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <ExternalLink className="w-4 h-4" />}
          {copy.stripePortal}
        </button>
      </div>
    </div>
  );
};

export default SubscriptionCard;
